var rmaxOptions = window.rmaxOptions || (window.rmaxOptions = {});
  // rmaxOptions.adHost = '//beta-ssp.tenmax.io';

var _rmaxads = (window.rmaxads || (window.rmaxads = {}));
(_rmaxads.cmd || (_rmaxads.cmd = [])).push(function(rmaxads) {
  rmaxads.on('space', function(space) {
    space.demo({
      crid: currentCreative,
      // toBeta: false
    });
  });
});

window.addEventListener("scroll", function() {
  let { height } = document.querySelector("#header > .container").getBoundingClientRect();
  if (window.scrollY >= height && window.innerWidth > 768) {
    document.body.classList.add("menuFixed");
  } else {
    document.body.classList.remove("menuFixed");
  }
});

let tenMaxAttr = [
  {
    name: "ASIAMAX_NATIVE",
    parameter: {
      "data-rmax-space-id":"59290d62db8742fb",
      "data-rmax-space-type":"NATIVE",
      "data-target-pos":"INNER"
    }, 
    script: "//tenmax-static.cacafly.net/ssp/adsbytenmax.js",
    crid: 37968
  }, {
    name: "ASIAMAX_BANNER",
    parameter: {
      "data-rmax-space-id":"6b6a131e633347fd",
      "data-rmax-space-type":"BANNER"
    },
    script: "//tenmax-static.cacafly.net/ssp/adsbytenmax.js",
    crid: 46226
  }, {
    name: "ASIAMAX_COMBO",
    parameter: {
      "data-rmax-space-id":"1e615494f98346ec",
      "data-rmax-space-type":"UNIVERSAL"
    },
    script: "//tenmax-static.cacafly.net/ssp/universal.js",
    crid: 19532
  }, 
  // {
  //   name: "PPS1",
  //   parameter: {
  //     "data-rmax-space-id":"cdecc578055b4b77",
  //     "data-rmax-space-type":"BANNER",
  //     "data-rmax-space-width":"300px",
  //     "data-rmax-space-height":"250px"
  //   },
  //   script: "//tenmax-static.cacafly.net/ssp/adsbytenmax.js",
  //   crid: 26435
  // }, {
  //   name: "PPS2",
  //   parameter: {
  //     "data-rmax-space-id":"59cda7b6d10a4614",
  //     "data-rmax-space-type":"BANNER",
  //     "data-rmax-space-width":"300px",
  //     "data-rmax-space-height":"250px"
  //   },
  //   script: "//tenmax-static.cacafly.net/ssp/adsbytenmax.js",
  //   crid: 26433
  // }, {
  //   name: "PPS3",
  //   parameter: {
  //     "data-rmax-space-id":"3d72f1550f6c4181",
  //     "data-rmax-space-type":"BANNER",
  //     "data-rmax-space-width":"300px",
  //     "data-rmax-space-height":"250px"
  //   },
  //   script: "//tenmax-static.cacafly.net/ssp/adsbytenmax.js",
  //   crid: 26433
  // }, {
  //   name: "PPS4",
  //   parameter: {
  //     "data-rmax-space-id":"50f0c350595c401f",
  //     "data-rmax-space-type":"BANNER",
  //     "data-rmax-space-width":"300px",
  //     "data-rmax-space-height":"250px"
  //   }, 
  //   script: "//tenmax-static.cacafly.net/ssp/adsbytenmax.js",
  //   crid: 26436}
];
let anchorPosition = ["readMore", "topOfArticle", "middleOfArticle", "bottomOfArticle", "interstitial"];
let currentType = 0, currentPosition = 0, currentCreative;
let queryString = location.search.toLowerCase();
let params = new URLSearchParams(queryString);
let randomMode = (function () {
  let intervalID;
  let state = false;
  const randomIntervalInSecs = 5;
  function getState() {
    return state;
  }
  function turnOn() {
    if (!state) {
      state = true;
      intervalID = setInterval(() => {
        let randomNum;
        do {
          randomNum = Math.floor(Math.random() * 3);
        } while (randomNum == currentType);
        changeType(randomNum);
      }, (randomIntervalInSecs * 1000));
      updateType();
    }
  }
  function turnOff() {
    if (state) {
      state = false;
      clearInterval(intervalID);
      updateType();
    }
  }
  function toggle() {
    if (!state) {
      turnOn();
    } else {
      turnOff();
    }
  }
  return {getState, turnOn, turnOff, toggle};
})();

window.onload = function () {
  dropdownBehavior();
  interstitialBehavior();
  init();
}

function init() {
  let videoCreative = params.get("vcreative");
  let adCreative = params.get("creative");
  loadingCard(true);
  let requests = [requestCreativeInfo(videoCreative), requestCreativeInfo(adCreative)];
  Promise.allSettled(requests).then(([videoPromise, adPromise]) => {
    console.log(adPromise);
    let videoInfo = videoPromise.status == "fulfilled" ? videoPromise.value : null;
    let adInfo = adPromise.status == "fulfilled" ? adPromise.value : null;
    let videoCrid = checkAndModifyVideoCreative(videoInfo);
    let [rowType, adCrid] = checkAndModifyAdCreative(adInfo);
    console.log(rowType, adCrid);
    initAd(rowType, adCrid);
    initVideo(videoCrid);
  }).then(() => {
    loadingCard(false);
  });
  function checkAndModifyVideoCreative(info) {
    if (!info) {
      return 19111;
    }
    return info.crid;
  }
  function checkAndModifyAdCreative(info) {
    console.log(info);
    let nonExists = !info;
    let rowType = !nonExists && (info.subType || info.rowType);
    let notSupported = rowType == "PPS";
    if (nonExists) {
      return [params.get("type") || "", null];
    }
    if (notSupported) {
      return ["", null];
    }
    if (rowType == "ASIAMAX_COMBO") {
      return ["ASIAMAX_COMBO", info.crid];
    }
    // if  (rowType == "banner" && (info.width != 300 || info.height != 250)) {
    //   return ["banner", null];
    // }
    return [rowType, info.crid];
  }
  function initVideo(crid) {
    crid ? setHrefParams("vcreative", crid) : deleteHrefParams("vcreative");
    let options = {
      id: "content_video",
      adTagUrl: `https://ssp.tenmax.io/supply/demo/video/rmax-ad?rmaxSpaceId=3b7e8b888f0140a9&domain=https://ssp.tenmax.io&demo=true&crid=${crid}&toBeta=false`
    };
    player.ima(options);
    player.ima.initializeAdDisplayContainer();
    player.ima.requestAds();
    player.play();
  }
  function initAd(type, crid) {
    let typeIndex = tenMaxAttr.findIndex(el => el.name == type);
    console.log(tenMaxAttr.findIndex(el => console.log(el.name)), type);
    if (typeIndex == -1) {
      changeType(currentType);
      randomMode.turnOn();
    } else {
      changeType(typeIndex, crid);
    }
    let position = params.get("position") || "";
    let positionIndex = anchorPosition.findIndex(el => el.toLowerCase() == position.toLowerCase());
    if (positionIndex == -1) {
      positionIndex = window.innerWidth > 768 ? 0 : 2;
    }
    changePosition(positionIndex);
  }
}

function loadingCard(status) {
  let interstitial = document.querySelector(".interstitial");
  let alertCard = document.querySelector(".interstitial > .alertCard");
  let loading = document.querySelector(".alertCard > .loading");
  let text = document.querySelector(".alertCard > p");
  if (status) {
    interstitial.style.display = "flex";
    alertCard.style.display = "flex";
    loading.style.display = "inline-block";
    text.innerText = `素材ID尋找中 =͟͟͞͞( •̀д•́)`;
  } else {
    interstitial.style.display = "none";
    alertCard.style.display = "none";
  }
}

function requestCreativeInfo(creativeID) {
  return new Promise((resolve, reject) => {
    if (!creativeID) {
      return reject();
    }
    let httpRequest = new XMLHttpRequest();
    if (!httpRequest) {
      return reject(`Giving up :( Cannot create an XMLHTTP instance`);
    }
    httpRequest.responseType = "json";
    httpRequest.onload = () => {
      httpRequest.status === 200 ? resolve(httpRequest.response) : reject(`bad request`);
    };
    httpRequest.open("GET", `https://ssp.tenmax.io/supply/util/creative/${creativeID}/info`);
    httpRequest.send();
  });
}

function setHrefParams(key, value) {
  params.set(key, value);
  history.replaceState(`?${params.toString()}`,"", `?${params.toString()}`);
}

function deleteHrefParams(key) {
  params.delete(key);
  history.replaceState(`?${params.toString()}`,"", `?${params.toString()}`);
}

// control type dropdown status (render)
function updateType() {
  document.querySelectorAll("#type > .dropdown > li:not(.randomMode)").forEach((btn, index) => {
    !randomMode.getState() && (index == currentType) ? btn.classList.add("active") : btn.classList.remove("active");
  });
  let randomModeBtn = document.querySelector("#type > .dropdown > li.randomMode");
  randomMode.getState() ? randomModeBtn.classList.add("active") : randomModeBtn.classList.remove("active");
  randomMode.getState() ? setHrefParams("type", "randomMode") : setHrefParams("type", tenMaxAttr[currentType].name.split("_")[1].toLowerCase());
}

function updatePosition() {
  document.querySelectorAll("#position > .dropdown > li").forEach((btn, index) => {
    index == currentPosition ? btn.classList.add("active") : btn.classList.remove("active");
  });
}

function dropdownBehavior() {
  document.querySelectorAll("#burger > aside > ul > li").forEach(el => {
    el.addEventListener("click", function() {
      this.classList.toggle("active");
      let siblings = n => [...n.parentElement.children].filter(c => c != n);
      siblings(el).forEach(sibling => sibling.classList.remove("active"));
    });
  });
  document.querySelectorAll(".dropdown > li").forEach(el => {
    el.addEventListener("click", function() {
      document.querySelector("#burger > input[type=checkbox]").checked = false;
    });
  });
  typeMenuBehavior();
  positionMenuBehavior();
}

function typeMenuBehavior() {
  document.querySelectorAll("#type > .dropdown > li:not(.randomMode)").forEach((el, index) => {
    el.addEventListener("click", function() {
      deleteHrefParams("creative");
      randomMode.turnOff();
      changeType(index);
    });
  });
  document.querySelector("#type > .dropdown > li.randomMode").addEventListener("click", function() {
    deleteHrefParams("creative");
    randomMode.toggle();
  });
}

function positionMenuBehavior() {
  document.querySelectorAll("#position > .dropdown > li").forEach((el, index) => {
    el.addEventListener("click", function() {
      changeType(currentType, currentCreative);
      changePosition(index);
    });
  });
}

function interstitialBehavior() {
  document.querySelector(".interstitial").addEventListener("click", function() {
    document.querySelector(".interstitial").style.display = "none";
  });
}

function changePosition(num) {
  currentPosition = num;
  setHrefParams("position", anchorPosition[currentPosition]);
  let adTest = document.querySelector("#adTest");
  let anchor = document.querySelector(`.${anchorPosition[currentPosition]}Anchor`);
  anchor.parentNode.insertBefore(adTest, anchor);
  if (currentPosition == 4) {
    document.querySelector(".interstitial").style.display = "flex";
  }
  updatePosition();
}

function changeType(num, crid = null) {
  currentType = num;
  currentCreative = crid || tenMaxAttr[currentType].crid;
  crid ? setHrefParams("creative", crid) : deleteHrefParams("creative");
  let adTest = document.querySelector("#adTest");
  adTest.querySelectorAll("ins, script, p").forEach(el => el.remove());
  insertAD(adTest, "async", tenMaxAttr[currentType]);
  updateType();
}

function insertAD(element, async, attributes) {
  let p = document.createElement("p");
  p.innerText = `廣告類型: ${attributes.name.split("_")[1]}`;
  element.appendChild(p);
  let ins = document.createElement("ins");
  ins.className = "rmax";
  ins.style.alignSelf = "center";
  for (let key in attributes.parameter) {
    ins.setAttribute(key, attributes.parameter[key]);
  }
  element.appendChild(ins);
  let script = document.createElement("script");
  script.src = attributes.script;
  script[async] = async;
  element.appendChild(script);
}

// need check
// Video Ad
var player = videojs('content_video');

// Remove controls from the player on iPad to stop native controls from stealing
// our click
var contentPlayer =  document.getElementById('content_video_html5_api');
if ((navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/Android/i)) &&
    contentPlayer.hasAttribute('controls')) {
    contentPlayer.removeAttribute('controls');
}

// Initialize the ad container when the video player is clicked, but only the
// first time it's clicked.
var startEvent = 'click';
if (navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/Android/i)) {
    startEvent = 'tap';
}
